import { FavoriteType } from '@kcftech/prometheus-client';
import { useFavoritesByType } from 'custom_hooks/data_hooks/favorites/useFavoritesByType';
import { CorporationOverviewFilters } from 'pages/Corporation/types';
import { useEffect, useMemo } from 'react';
import { QuickFilterConfig, QuickFilterPane } from 'shared/filter_pane/QuickFilterPane';

const calculateFilterCount = (filters: CorporationOverviewFilters) =>
    filters.favoritesFilter ? 1 : 0;

export type CorporationOverviewFilterPaneProps = Readonly<{
    corporationId: string;
    filters: CorporationOverviewFilters;
    onChange: (filters: CorporationOverviewFilters) => void;
}>;

export function CorporationOverviewFilterPane({
    corporationId,
    filters,
    onChange,
}: CorporationOverviewFilterPaneProps) {
    const favorites = useFavoritesByType({ type: FavoriteType.Location, corporationId });

    const filterCount = calculateFilterCount(filters);

    const quickFilters = useMemo<QuickFilterConfig<CorporationOverviewFilters>[]>(
        () => [
            {
                id: 'favorites',
                label: 'Favorite Locations',
                value: 'favorites',
                field: 'favoritesFilter',
                disabled: favorites.length === 0,
                title:
                    favorites.length === 0
                        ? 'No favorite locations. Please select a favorite to filter.'
                        : undefined,
            },
        ],
        [favorites],
    );

    useEffect(() => {
        // If the favorites filter is active but there are no favorites, reset the filter
        if (filters.favoritesFilter === 'favorites' && favorites.length === 0) {
            onChange({ ...filters, favoritesFilter: undefined });
        }
    }, [favorites, filters, onChange]);

    return (
        <QuickFilterPane
            id="filter-pane"
            filters={filters}
            quickFilters={quickFilters}
            onChange={onChange}
            filterCount={filterCount}
        />
    );
}
